import React, { useEffect, useRef } from "react";
import "./FlipCard.scss";
import "./FlipCard.css";
import { addStyles, StaticMathField } from "react-mathquill";
import { useState } from "react";
import { useSpeechSynthesis } from "react-speech-kit";
import { isMobile } from "react-device-detect";
import ProgressBar from "@ramonak/react-progress-bar";
import { useFlipcardState } from "./FlipcardStateContext"; // Adjust the path as needed

function FlipCard(props) {
  const flipCard = useRef();
  const { updateState } = useFlipcardState();
  const [flipped, setFlipped] = useState(true);
  const canHover = window.matchMedia("(hover: hover)").matches;
  const { speak, cancel, speaking, supported, voices } = useSpeechSynthesis();
  const voiceIndex = props.selectedVoiceIndex ?? 1;

  const [editMode, setEditMode] = useState(false);
  const [inputValue, setInputValue] = useState(
    parseInt(props.currentCard.num) + 1
  );
  const [hovered, setHovered] = useState(false);
  const handleMouseEnter = () => {
    setHovered(true);
  };

  const handleMouseLeave = () => {
    if (!editMode) {
      setHovered(false);
    }
  };

  const handleElementClick = () => {
    setEditMode(true);
  };

  const handleInputBlur = () => {
    setEditMode(false);
  };

  let flipno = () => {
    setFlipped(!flipped);
  };

  useEffect(() => {
    setInputValue(parseInt(props.currentCard.num) + 1);
  }, [props.currentCard.num]);

  useEffect(() => {
    updateState(!flipped);
  }, [flipped, updateState]);

  return (
    <>
      <div
        className="flipcard-cover"
        style={{
          display: "flex",
          flexDirection: "column",
          maxWidth: "640px",
          alignItems: "center",
          width: "100%",
        }}
      >
        <div
          className="flip"
          ref={flipCard}
          onMouseEnter={
            isMobile
              ? () => {
                  return false;
                }
              : () => {
                  if (
                    canHover &&
                    props.soundEnabled &&
                    !props.currentCard.back_equation
                  ) {
                    cancel();
                    speak({
                      text: props.currentCard.back,
                      voice: voices[voiceIndex],
                    });
                  }

                  setFlipped(false);
                }
          }
          onMouseLeave={
            isMobile
              ? () => {
                  return false;
                }
              : () => {
                  if (
                    canHover &&
                    props.soundEnabled &&
                    !props.currentCard.front_equation
                  ) {
                    cancel();
                    speak({
                      text: props.currentCard.front,
                      voice: voices[voiceIndex],
                    });
                  }
                  setFlipped(true);
                }
          }
          onClick={() => {
            if (isMobile) {
              if (!canHover) {
                if (!flipped) {
                  if (props.soundEnabled && !props.currentCard.back_equation) {
                    cancel();
                    speak({
                      text: props.currentCard.back,
                      voice: voices[voiceIndex],
                    });
                  }
                } else {
                  if (props.soundEnabled && !props.currentCard.front_equation) {
                    cancel();
                    speak({
                      text: props.currentCard.front,
                      voice: voices[voiceIndex],
                    });
                  }
                }
              }
              flipno();
            }
          }}
          onAnimationEnd={props.onAnimationEnd}
          appear={props.appear}
          slideleft={props.slideleft}
          slideright={props.slideright}
        >
          <div className={flipped ? "front rotate-yes" : "front rotate-no"}>
            {props.currentCard.front_img != undefined && (
              <img
                className="card-img"
                src={props.currentCard.front_img}
                alt="front card"
              ></img>
            )}
            {props.currentCard.front_equation ? (
              <StaticMathField>{props.currentCard.front}</StaticMathField>
            ) : (
              <h4 className="fronth4">{props.currentCard.front}</h4>
            )}
            {props.currentCard.is_mdt && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="37"
                height="37"
                viewBox="0 0 37 37"
                className="most-difficult-term-mark"
              >
                <g
                  id="Group_2070"
                  data-name="Group 2070"
                  transform="translate(-679 -397)"
                >
                  <circle
                    id="Ellipse_489"
                    data-name="Ellipse 489"
                    cx="18.5"
                    cy="18.5"
                    r="18.5"
                    transform="translate(679 397)"
                    fill="#8358e8"
                  />
                  <path
                    id="sentiment_stressed_FILL0_wght400_GRAD0_opsz48"
                    d="M86.482,188.607l4.252-3.092-4.252-3.092-1.07,1.427,2.29,1.665-2.29,1.665Zm10.823,0,1.07-1.427-2.29-1.665,2.29-1.665-1.07-1.427-4.252,3.092Zm-7.2,5.293,1.784-1.784,1.784,1.784,1.784-1.784,1.16,1.16,1.249-1.249-2.408-2.408L93.678,191.4l-1.784-1.784L90.109,191.4l-1.784-1.784-2.408,2.408,1.249,1.249,1.16-1.16Zm1.784,5.887a11.581,11.581,0,0,1-4.638-.937,11.875,11.875,0,0,1-6.318-6.318,11.954,11.954,0,0,1,0-9.277,11.875,11.875,0,0,1,6.318-6.318,11.954,11.954,0,0,1,9.277,0,11.875,11.875,0,0,1,6.318,6.318,11.954,11.954,0,0,1,0,9.277,11.875,11.875,0,0,1-6.318,6.318A11.582,11.582,0,0,1,91.894,199.787ZM91.894,187.893Zm0,10.109a10.032,10.032,0,1,0-7.171-2.938A9.757,9.757,0,0,0,91.894,198Z"
                    transform="translate(605.607 227.606)"
                    fill="#fff"
                  />
                </g>
              </svg>
            )}
          </div>
          <div className={flipped ? "back rotate-no" : "back rotate-yes"}>
            {props.currentCard.back_img != undefined && (
              <img
                className="card-img"
                alt="back card"
                src={props.currentCard.back_img}
              ></img>
            )}
            {props.currentCard.back_equation ? (
              <StaticMathField>{props.currentCard.back}</StaticMathField>
            ) : (
              <p className="backp">{props.currentCard.back}</p>
            )}
            {props.currentCard.is_mdt && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="37"
                height="37"
                viewBox="0 0 37 37"
                className="most-difficult-term-mark"
              >
                <g
                  id="Group_2070"
                  data-name="Group 2070"
                  transform="translate(-679 -397)"
                >
                  <circle
                    id="Ellipse_489"
                    data-name="Ellipse 489"
                    cx="18.5"
                    cy="18.5"
                    r="18.5"
                    transform="translate(679 397)"
                    fill="#8358e8"
                  />
                  <path
                    id="sentiment_stressed_FILL0_wght400_GRAD0_opsz48"
                    d="M86.482,188.607l4.252-3.092-4.252-3.092-1.07,1.427,2.29,1.665-2.29,1.665Zm10.823,0,1.07-1.427-2.29-1.665,2.29-1.665-1.07-1.427-4.252,3.092Zm-7.2,5.293,1.784-1.784,1.784,1.784,1.784-1.784,1.16,1.16,1.249-1.249-2.408-2.408L93.678,191.4l-1.784-1.784L90.109,191.4l-1.784-1.784-2.408,2.408,1.249,1.249,1.16-1.16Zm1.784,5.887a11.581,11.581,0,0,1-4.638-.937,11.875,11.875,0,0,1-6.318-6.318,11.954,11.954,0,0,1,0-9.277,11.875,11.875,0,0,1,6.318-6.318,11.954,11.954,0,0,1,9.277,0,11.875,11.875,0,0,1,6.318,6.318,11.954,11.954,0,0,1,0,9.277,11.875,11.875,0,0,1-6.318,6.318A11.582,11.582,0,0,1,91.894,199.787ZM91.894,187.893Zm0,10.109a10.032,10.032,0,1,0-7.171-2.938A9.757,9.757,0,0,0,91.894,198Z"
                    transform="translate(605.607 227.606)"
                    fill="#fff"
                  />
                </g>
              </svg>
            )}
          </div>
        </div>
        <div
          className="num-cover"
          style={{ display: "flex", alignItems: "center", gap: "5px" }}
        >
          {" "}
          <p
            className="mobile-arrow"
            id="mobile-arrow-left"
            onClick={(e) => {
              e.stopPropagation(); // prevent event propagation
              setFlipped(true);
              props.onLeftArrowClicked(e);
            }}
            style={{ opacity: props.currentCard.num == 0 ? 0.3 : 1 }}
          >
            <svg
              style={{ marginBottom: "0px" }}
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 -960 960 960"
              width="24"
            >
              <path
                d="M400-240 160-480l240-240 56 58-142 142h486v80H314l142 142-56 58Z"
                fill="#575757"
              />
            </svg>
          </p>
          {hovered ? (
            <input
              type="number"
              className="num"
              defaultValue={inputValue}
              onBlur={handleInputBlur}
              min={1}
              max={props.nterms}
              onChange={(event) => {
                const newValue = parseInt(event.target.value);
                if (!isNaN(newValue)) {
                  setInputValue(newValue);
                  props.setCardIndex(newValue - 2);
                }
              }}
              onMouseLeave={handleMouseLeave} // When mouse leaves the input
              autoFocus
              style={{ opacity: 1 }} // Opaque if hovered, normal if in edit mode
            />
          ) : (
            <p
              className="num"
              onClick={handleElementClick}
              onMouseEnter={handleMouseEnter} // When mouse enters the paragraph
              onMouseLeave={handleMouseLeave} // When mouse leaves the paragraph
              style={{ width: "auto", cursor: "pointer" }}
            >
              {props.currentCard.num + 1}
            </p>
          )}
          <p className="num" style={{ width: "auto" }}>
            {" "}
            of {props.nterms}
          </p>
          <a
            className="mobile-arrow"
            id="mobile-arrow-right"
            onClick={(e) => {
              e.stopPropagation(); // prevent event propagation
              setFlipped(true);
              props.onRightArrowClicked(e);
            }}
            style={{
              opacity: props.currentCard.num == props.nterms - 1 ? 0.3 : 1,
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 -960 960 960"
              width="24"
            >
              <path
                d="m560-240-56-58 142-142H160v-80h486L504-662l56-58 240 240-240 240Z"
                fill="#575757"
              />
            </svg>
          </a>
        </div>
      </div>
    </>
  );
}

export default FlipCard;
